<main class="login-shell">
  <section class="form-panel" aria-labelledby="change-password-title">
    <div class="login-card">
      <h2 id="change-password-title">{{ i18n.t('auth.changePassword.title') }}</h2>
      <p>{{ i18n.t('auth.changePassword.subtitle') }}</p>
      <form class="app-form" [formGroup]="form" (ngSubmit)="submit()">
        <label class="app-field"><span class="app-field__label">{{ i18n.t('auth.changePassword.newPassword') }}</span><input type="password" formControlName="password" autocomplete="new-password" /></label>
        <label class="app-field"><span class="app-field__label">{{ i18n.t('auth.changePassword.confirmPassword') }}</span><input type="password" formControlName="confirmation" autocomplete="new-password" /></label>
        @if (error()) { <p class="form-message">{{ error() }}</p> }
        <button class="primary-button" type="submit" [disabled]="submitting()">{{ submitting() ? i18n.t('auth.changePassword.saving') : i18n.t('auth.changePassword.submit') }}</button>
      </form>
    </div>
  </section>
</main>
